<template>
    <div class="ve-list-page ve-list-page--embedded">
 
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;font-weight:600;white-space:nowrap;">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
     
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>   
        <ve-table class="ve-list-page__table" :columns="vueCol"
            :table-data="tabData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            :scroll-width="0"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :event-custom-option="eventCustomOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :column-width-resize-option="columnWidthResizeOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            ref="refreq">
        </ve-table>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 分页查询 -->
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol" :key="index" >
                        <FormItem   :label="$translate.getColTitle(item, $store.state.lang)"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select size="medium" @change="selChg" v-else-if="item.key==='JOBTY'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in tyArr " :key="index" :label="item.SUBNO" :value="item.CODE"></el-option>
                            </el-select>
                            <el-select size="medium" @change="jobChg" v-else-if="item.key==='JOBNM'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in jobArr " :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                            </el-select>
                            <el-select size="medium" v-else-if="item.edcss==='select'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">            
 
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
 
export default {
    name:'std_joblibrary_two',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '411301',
            fieldIdseq: '411301',
            fieldLstseq: '2',
            mainColumnKey: 'tabCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        }),
    ],
    data () {
        return {
            dtlRow:{},
            sendVal:'PRD',
            tyArr:[],
            dtlWin:false,

  
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
 
            actitem:'one',
       
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            v_row:{},
            selparam:'TYNM',
            txtparam:'',
            poRow:{},
            jobArr:[],
            goPage:'',
            rowIdseq:'',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            v_commit :true,
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            options: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                } ],
            dataCount:0,
            comboArr:[],
            rowSize:50,
 
            tabCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            eventCustomOption: {
                bodyRowEvents: ({ row, rowIndex }) => ({ click: () => this.rowClick(row, rowIndex) }),
            },
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
            operArr:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            v_key:'',
            oper:'like',
 
            v_tabRow:{},
            v_tabIndex:'',
            v_idseq:this.$cookies.get('idseq'),
            stfgBool:true,
        }
    },
    components: {
        pubWin,
        VeColumnConfigDialog,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 270) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth- 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        this.comSelect()
  
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','411301','LSTSEQ','2','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','461228','','','v_sys_base',' and code not in (461229)').then(res=>{
            this.tyArr =res.result            
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','461230','','','v_sys_base','').then(res=>{
            this.jobArr =res.result            
        }) 
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getTabList('', ++this.queryRequestId)
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        selChg(val){
            this.poRow['JOBNM']=''
            this.jobArr=[]
            this.$axios({
                method: 'post',
                url: 'xuper_auth/getBaseData',
                data: {p_key:'parentno',p_value:val,p_table:'v_sys_base' },
            }).then(res=>{ 
                this.jobArr=res.result
                this.$forceUpdate()
            })
        },
        jobChg(){
            this.$forceUpdate()
        },
        itemClick(val){
            this.actitem =val     
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.$set(this.v_row, item, '')
            })
            this.current = 1
            this.headerSortKey = ''
            this.headerSortOrder = ''
            this.getTabList('', ++this.queryRequestId)
        } ,
        rowClick(row, rowIndex){
            this.chkIndex =rowIndex
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM']  } ))
                this.$refs['pos'+ this.v_tabIndex+'ACTQTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            } 
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                // this.v_tabRow =row
                // this.v_tabIndex =index
                // this.v_table ='v_bs_mat'
                // this.tableCol =this.prodCol
                // this.v_key2 ='modelno'
                // this.v_value2 = row['MATTY']
                // this.btnWin =true
            }
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'411301',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
 
 
        //编辑记录
        editRec(row,val,index){
 
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
 
            this.addWin=true  
            this.v_commit =true     
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid})), p_table:'BS_LIBITM',frmid:''},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq

                        this.v_commit =false
                        this.addWin =false   
                        this.getTabList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                })    
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.dtlData=[]
            this.poRow={ICDTTM:getDate('day'),'IDSEQ':'',IDTY:'INIT' }
            this.v_commit =true
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                v_comm=this.$LANG('0134', '审核')
            }else if (val==='N'){
                v_comm=this.$LANG('0137', '弃审')
            }else if (val==='X'){
                v_comm=this.$LANG('0131', '删除')
            }
 
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_LIBITM' },
                }).then(res=>{      
                    if(res.code =='200')  {   
                        if (val=='X'){
                            this.tabData.splice(index,1)
                        }else{         
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                        }
                    }else{
                        if (res.result.indexOf('ORA-04088')>-1){
                            this.prompt=this.$LANG('1559', '库存数量不足，请核查')
                        }else{
                            this.prompt=res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        buildQueryCondition(){
            return buildVeTableHeaderCondition(this.initCol, this.v_row)
                + buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
        },
        stfgChange(){
            this.current = 1
            this.headerSortKey = ''
            this.headerSortOrder = ''
            this.getTabList(this.buildQueryCondition(), ++this.queryRequestId)
        },
        sortHeaderColumn(column){
            const key = column && (column.field || column.key)
            if (!isVeTableMetadataField(this.initCol, key) || key === 'RN') return
            const previousKey = this.headerSortKey
            const previousOrder = this.headerSortOrder
            this.headerSortKey = key
            this.headerSortOrder = previousKey === key && previousOrder === 'asc' ? 'desc' : 'asc'
            this.current = 1
            this.getTabList(this.buildQueryCondition(), ++this.queryRequestId, ` order by ${key} ${this.headerSortOrder}`)
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.tabData = this.allList          
            }else{
             
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
 
        //查询界面
        getTabList(cond, requestId, sortClause){
            let vm =this
            this.v_loading =true
            getTabColOrData(this.v_url,'V_BS_LIBITM','','','CORPID',this.v_corpid,'','',cond + (sortClause || ' order by tynm,jobty') ).then((res) => {
                if (requestId && requestId !== this.queryRequestId) return
                this.allList =res.result 
                this.initPage() 
                this.v_loading =false
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','411301','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings()
            }).then(() => {
                const fieldRows = vm.sortFieldRows(vm.initCol)
                vm.tabCol = []
                vm.vueCol = []
                fieldRows.forEach(rowField => {
                    const title = vm.$translate.getColTitle(rowField, vm.$store.state.lang)
                    const type = String(rowField.EDCSS || '').toLowerCase()
                    vm.tabCol.push({
                        title,
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide: rowField.THIDE,
                        fhide: rowField.FHIDE,
                        edcss: rowField.EDCSS,
                        disabled: rowField.DISABLED,
                        dotnum: rowField.DOTNUM,
                        sortable: rowField.SORTABLE,
                    })
                    if (rowField.THIDE !== 'N') return
                    vm.vueCol.push({
                        field: rowField.key,
                        key: rowField.key,
                        title,
                        align: rowField.align,
                        width: Number(rowField.width) || 120,
                        sortable: rowField.key !== 'RN' && rowField.SORTABLE === 'N' && type !== 'checkbox',
                        ellipsis: { showTitle: true },
                        renderHeaderCell: ({column}) => <VeTableQueryHeader
                            title={column.title}
                            edcss={rowField.EDCSS || rowField.edcss}
                            options={vm.comboArr[rowField.key] || []}
                            value={vm.v_row[rowField.key]}
                            operator={vm.v_row[`#OPER${rowField.key}`]}
                            sortable={rowField.key !== 'RN' && rowField.SORTABLE === 'N' && type !== 'checkbox'}
                            sortOrder={vm.headerSortKey === rowField.key ? vm.headerSortOrder : ''}
                            on-input={(value) => vm.$set(vm.v_row, rowField.key, value)}
                            on-operator-change={(value) => vm.$set(vm.v_row, `#OPER${rowField.key}`, value)}
                            on-title-click={() => vm.sortHeaderColumn(column)}
                            on-query={vm.stfgChange}
                        />,
                        renderBodyCell: ({row}) => {
                            const value = row[rowField.key]
                            if (rowField.key === 'IDNO2') return <el-link underline={false} on-click={() => vm.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:11px">{value}</div></el-link>
                            if (rowField.key === 'STFG') return value === 'Y'
                                ? <el-tag size="mini" type="success" effect="dark" style="text-align:center">{vm.$LANG('1976', '已审核')}</el-tag>
                                : <el-tag size="mini" type="info" effect="dark" style="text-align:center">{vm.$LANG('2005', '未审核')}</el-tag>
                            if (type === 'checkbox') return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[rowField.key]} style="width:100%">&nbsp;</el-checkbox>
                            return <span style="float:left">{value}</span>
                        },
                    })
                })
                vm.vueCol.unshift({
                    field: 'index',
                    key: 'rownum',
                    title: vm.$LANG('0310', '序号'),
                    width: 60,
                    align: 'center',
                    fixed: 'left',
                    disableResizing: true,
                    renderBodyCell: ({rowIndex}) => rowIndex + 1,
                    renderHeaderCell: () => <el-link on-click={vm.rowShow} style="font-size:12px;color:#fff"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1" style="color:#409eff"></i></el-tooltip></el-link>,
                })
                vm.vueCol.push({
                    field: 'oper0',
                    key: 'oper',
                    title: vm.$LANG('0870', '状态操作'),
                    width: 175,
                    align: 'center',
                    fixed: 'right',
                    disableResizing: true,
                    renderBodyCell: ({row, rowIndex}) => (
                        <div>
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                            <el-link on-click={() => vm.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:10px">{vm.$LANG('0139', '查看')}</span></el-link>
                            <span>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => vm.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:10px">{vm.$LANG('1639', '编辑')}</span></el-link>
                            </span>
                            {row.STFG === 'N' ? <span>
                                <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i>
                                <el-link on-click={() => vm.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px">{vm.$LANG('0131', '删除')}</span></el-link>
                            </span> : null}
                        </div>
                    ),
                })
                vm.applyFieldSettingRows()
            })
 
 
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
